<template>
    <!-- The result will automatically updated -->
    <!--    <p v-show="loading">Loading..</p>-->
    <div v-for="(item, index) in tangItems.data.blogEntries" v-if="tangItems != null"
         style="display: flex;flex-flow: column;">
        <h4 v-if="xNewsTitle != null" class="external-source__title">{{ xNewsTitle }}</h4>
        <div class="news__article-content">
            <img v-if="heroImg != null" :alt="heroImgCaption != '' ? heroImgCaption : heroImgAlt"
                 :src="heroImg"
                 :srcset="heroImgSrcset"
                 class="image__image-asset"/>
            <img v-for="img in item.thumbnailImage" v-else-if="item.thumbnailImage != ''" :alt="img.alt"
                 :srcset="img.srcset"
                 class="image__image-asset"/>
            <div class="news__article-bottom">
                <!--                <div class="news__external-source-logo"></div>-->
                <!--                <PageCMSArticle :cmsData="props.cmsData"></PageCMSArticle>-->
                <div class="article-bottom">
                    <div class="article-bottom__left">

                        <a :href="item.url" class="news__article-title" target="_blank">{{ item.title }}<i
                            class="fa-regular fa-arrow-up-right-from-square external-link"></i></a>
                        <p v-if="item.shortDescription !== ''" class="news__article-body">{{
                                item.shortDescription
                            }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--    <p v-else-if="error">error: {{ error }}</p>-->
</template>


<script setup>
import { ref } from 'vue'

// variables
const tangFeedURL = import.meta.env.VITE_TANG_FEED_API_TARGET
const tangAuth = import.meta.env.VITE_TANG_FEED_API_AUTH
const tangItems = ref(null)

const props = defineProps({
    cmsData: {
        type: Array,
        required: true,
    },
    heroImg: String,
    heroImgSrcset: String,
    heroImgAlt: String,
    heroImgCaption: String,
    xNewsTitle: String
})

const xNewsTitle = props.cmsData[0].externalNewsSourceTitle
const heroImg = props.cmsData[0].heroSrc
const heroImgSrcset = props.cmsData[0].heroSrcset
const heroImgAlt = props.cmsData[0].heroAlt
const heroImgCaption = props.cmsData[0].heroCaption
// console.log(props.cmsData[0].heroSrc)
console.log(heroImg)
console.log(heroImgSrcset)
// let base64 = require('base-64')

// authentication
//headers.append('Content-Type', 'text/json');
const authentication = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + tangAuth
}
const headers = new Headers(authentication)

// fetch
fetch(tangFeedURL, {
    method: 'POST',
    headers: headers,
    //credentials: 'user:passwd'
    body: JSON.stringify({
        query: `query BlogEntries {
              blogEntries(limit: 1) {
                ... on blog_blog_Entry {
                  id
                  url
                  shortDescription
                  title
                  thumbnailImage {
                    ... on media_Asset {
                      id
                      srcset(sizes: "700")
                      title
                      alt
                    }
                  }
                }
              }
            }
        `,
    }),
})
    .then(response => response.json())
    .then(data => tangItems.value = data)
    .then(json => console.log(json))

//.done();
// export default {
//     props: {
//         cmsData: {
//             type: Array,
//             required: true,
//         }
//     },
//     setup (props) {
//         console.log(props)
//         const {
//             result,
//             loading,
//             error
//         } = useQuery(gql`
//           query BlogEntries {
//               blogEntries(limit: 1) {
//                 ... on blog_blog_Entry {
//                   id
//                   url
//                   shortDescription
//                   title
//                   thumbnailImage {
//                     id
//                     ... on media_Asset {
//                       id
//                       srcset(sizes: "700")
//                       title
//                       alt
//                     }
//                   }
//                 }
//               }
//             }
//         `)
//         watch(result, value => {
//             console.log(value)
//         })
//
//         return {
//             result,
//             loading,
//             error,
//             // stripHtml,
//         }
//     },
//     components: {
//         PageArticle
//     },
// //
// }

</script>
